import { CaseNoPrincipalActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { GetProviderReportsAction } from './providerReport-actions';

export interface GetCaseNoPrincipalsAction {
    type: typeof CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS;
    payload: QueryParams;
    all?: any;
}

export function getCaseNoPrincipals(params: QueryParams): GetCaseNoPrincipalsAction {
    return {
        type: CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS,
        payload: params,
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}
export function getCaseNoPrincipalsCsv(params: QueryParamsAll): GetProviderReportsAction {
    return {
        type: CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPALS_CSV,
        payload: params,
    };
}

export interface GetCaseNoPrincipalAction {
    type: typeof CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPAL;
    payload: {
        id: string | number;
    };
}

export function getCaseNoPrincipal(id: string | number): GetCaseNoPrincipalAction {
    return {
        type: CaseNoPrincipalActions.FETCH_CASE_NO_PRINCIPAL,
        payload: { id },
    };
}

export interface DeleteCaseNoPrincipalAction {
    type: typeof CaseNoPrincipalActions.DELETE_CASE_NO_PRINCIPAL;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteCaseNoPrincipal(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteCaseNoPrincipalAction {
    return {
        type: CaseNoPrincipalActions.DELETE_CASE_NO_PRINCIPAL,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetCaseNoPrincipalsAction | GetCaseNoPrincipalAction | DeleteCaseNoPrincipalAction;
